"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactTextareaAutosize = _interopRequireDefault(require("react-textarea-autosize"));

var _classnames = _interopRequireDefault(require("classnames"));

var _emotionTheming = require("emotion-theming");

var _MultilineInput = _interopRequireDefault(require("./MultilineInput.style"));

var _class;

var TextAreaSimple = function TextAreaSimple(props) {
  return _react.default.createElement("textarea", props);
};

var MultilineInput = (0, _emotionTheming.withTheme)(_class =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(MultilineInput, _PureComponent);

  function MultilineInput() {
    (0, _classCallCheck2.default)(this, MultilineInput);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(MultilineInput).apply(this, arguments));
  }

  (0, _createClass2.default)(MultilineInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          autosize = _this$props.autosize,
          className = _this$props.className,
          theme = _this$props.theme,
          withBorder = _this$props.withBorder,
          otherProps = (0, _objectWithoutProperties2.default)(_this$props, ["autosize", "className", "theme", "withBorder"]);
      var TextArea = autosize ? _reactTextareaAutosize.default : TextAreaSimple;
      var classSet = (0, _classnames.default)(className, (0, _MultilineInput.default)(theme, withBorder));
      return _react.default.createElement(TextArea, (0, _extends2.default)({
        className: classSet
      }, otherProps));
    }
  }]);
  return MultilineInput;
}(_react.PureComponent)) || _class;

MultilineInput.defaultProps = {
  className: '',
  autosize: false
};
MultilineInput.propTypes = {
  className: _propTypes.default.string,
  autosize: _propTypes.default.bool
};
var _default = MultilineInput;
exports.default = _default;